export enum reactQueryKeys {
    usersList = 'usersList',
    userData = 'userData',
}
